export default __webpack_public_path__ + "static/media/incoming-video-call.91fb8e60.svg";